import { Directive, ElementRef, Input, ViewContainerRef } from '@angular/core';
import { TranslateService } from '../Services/translate.service';

@Directive({ standalone: false, selector: 't' })
export class TranslateStaticAlias {
	// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
	@Input('d') data: Object;

	constructor(
		_elementRef: ElementRef,
		viewContainer: ViewContainerRef,
		private translateService: TranslateService,
	) {
		let el: HTMLElement = _elementRef.nativeElement;

		setTimeout(() => {
			var key = el.innerHTML;
			var translation = this.translateService.get(key, '<span style="color:red;">' + key + '</span>');

			for (var k in this.data) translation = translation.replace('{{' + k + '}}', this.data[k]);

			el.insertAdjacentHTML('afterend', translation);
			el.parentNode.removeChild(el);
		});
	}
}

@Directive({ standalone: false, selector: '[t]' })
export class TranslateDynamicAlias {
	@Input('t') alias: string;
	// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
	@Input('d') data: Object;

	constructor(
		private _elementRef: ElementRef,
		private translateService: TranslateService,
	) {}

	ngOnInit() {
		let el: HTMLElement = this._elementRef.nativeElement;

		var translation = this.translateService.get(this.alias, '<span style="color:red;">' + this.alias + '</span>');

		for (var k in this.data) translation = translation.replace('{{' + k + '}}', this.data[k]);

		el.insertAdjacentHTML('afterend', translation);
		el.parentNode.removeChild(el);
	}
}

@Directive({ standalone: false, selector: '[tplaceholder]' })
export class TranslatePlaceholderDynamicAlias {
	@Input('tplaceholder') alias: string;

	constructor(
		private _elementRef: ElementRef,
		private translateService: TranslateService,
	) {}

	ngOnInit() {
		let el: HTMLElement = this._elementRef.nativeElement;

		var translation = this.translateService.get(this.alias, this.alias);

		el.setAttribute('placeholder', translation);
	}
}
